import { NavLink } from 'react-router-dom'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import { SidebarTooltip } from './SidebarTooltip'
import type { NavigationItem } from '../../types/workspace'

interface SidebarNavItemProps {
  item: NavigationItem
  isExpanded: boolean
}

export function SidebarNavItem({ item, isExpanded }: SidebarNavItemProps) {
  const Icon = item.icon
  const badgeValue = item.badge?.()

  const tooltipContent = (
    <>
      {item.name}
      {badgeValue != null && ` (${badgeValue})`}
    </>
  )

  const icon = (
    <span className="flex h-4 w-4 shrink-0 items-center justify-center">
      <Icon className="h-4 w-4" />
    </span>
  )

  const iconNode = !isExpanded ? (
    <SidebarTooltip content={tooltipContent} side="right">
      {icon}
    </SidebarTooltip>
  ) : (
    icon
  )

  return (
    <NavLink
      to={item.href}
      className={({ isActive }) =>
        cn(
          'group flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-all duration-200',
          isActive
            ? 'bg-accent/50 text-foreground font-medium'
            : 'text-muted-foreground hover:bg-accent/30 hover:text-foreground'
        )
      }
    >
      {iconNode}
      <span
        className={cn(
          'truncate transition-all duration-200',
          isExpanded ? 'opacity-100 w-auto' : 'opacity-0 w-0 overflow-hidden'
        )}
      >
        {item.name}
      </span>
      {isExpanded && badgeValue != null && (
        <Badge variant="secondary" className="ml-auto text-xs px-1.5 py-0 h-5">
          {badgeValue}
        </Badge>
      )}
    </NavLink>
  )
}
